import { request } from "@/request/http";

/**
 * @name: 学校管理接口
 * @author: LXY
 * @date: 2022-02-28 
 */
export default {
    // 获取学校列表
    getExpBookList: (data) => {
        return request("POST", `/index.php/adminExpBook/getExpBookList`, data);
    },
    // 添加/修改学校信息
    reviewExpBook: (data) => {
        return request("POST", `/index.php/adminExpBook/reviewExpBook`, data);
    },
    // 获取修改学校信息
    getExpBookInfo: (data) => {
        return request("POST", `/index.php/adminExpBook/getExpBookInfo`, data);
    },
    // 删除学校
    delSpitKeyword: (data) => {
        return request("POST", `/index.php/adminSpit/delSpitKeyword`, data);
    },
    // 上传学校logo
    updateSchoolLogo: (data) => {
        return request("POST", `/index.php/adminSchool/updateSchoolLogo`, data);
    },
    // 获取虚拟实验列表
    getSchoolExpList: (data) => {
        return request("POST", `/index.php/adminSchool/getSchoolExpList`, data);
    },
    // 授权学校虚拟实验
    grantSchoolExp: (data) => {
        return request("POST", `/index.php/adminSchool/grantSchoolExp`, data);
    },
};